/* eslint-disable react/prop-types */
import React, { FunctionComponent, ChangeEvent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledLabel, StyledInput, Required } from "./styles";

export interface TextInputProps {
  name: string;
  placeholder?: string;
  value?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  maxWidth?: number;
  type: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const TextInput: FunctionComponent<TextInputProps> = ({
  name,
  placeholder,
  label,
  value,
  disabled,
  onChange,
  maxWidth,
  required,
  type,
}) => (
  <Theme>
    {label && (
      <StyledLabel htmlFor={name} disabled={disabled}>
        {label}
        {required && <Required disabled={disabled} />}
      </StyledLabel>
    )}
    <StyledInput
      name={name}
      type={type}
      data-testid="text-input"
      maxWidth={maxWidth}
      id={name}
      aria-label={label}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onChange={onChange}
    />
  </Theme>
);

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  maxWidth: PropTypes.number,
};

TextInput.defaultProps = {
  placeholder: null,
  value: null,
  label: null,
  disabled: null,
  required: null,
  maxWidth: null,
};

export default TextInput;
